import { Link } from 'react-router-dom';
import PostCard from '@/components/base/PostCard';
import { categories, posts } from '@/mocks/posts';

export default function CategoryBlock({ slug }: { slug: string }) {
  const category = categories.find((c) => c.slug === slug);
  if (!category) return null;

  const list = posts.filter((p) => p.categorySlug === slug).slice(0, 3);

  return (
    <section className="w-full px-4 py-10 md:px-8" aria-labelledby={`block-${slug}`}>
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-foreground-950 text-background-50">
            <i className={`${category.icon} text-lg`} aria-hidden="true"></i>
          </span>
          <div>
            <h2 id={`block-${slug}`} className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {category.label}
            </h2>
            <p className="mt-1 max-w-xl text-sm text-foreground-600">{category.desc}</p>
          </div>
        </div>
        <Link
          to={`/category/${slug}`}
          className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          进入栏目
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((post) => (
          <PostCard key={post.id} post={post} variant="grid" />
        ))}
      </div>
    </section>
  );
}